<div class='container'>
  <p>
    <span i18n="@@footer-copyright">© Frog Connexion 2018-2023</span>
    <br/><span>www {{version}} - api {{apiVersion}} last deploy {{apiLastDeploy | date:'medium'}}</span>
    <br/>
  </p>
</div>
